// Generated from src/content/projects. Do not edit.
export const PROJECT_COLLABORATORS = {};
export const PROJECT_ARCHIVE_DISCIPLINES = {
  "architecture": {
    "sk": "ARCHITEKTÚRA",
    "en": "ARCHITECTURE"
  },
  "interior": {
    "sk": "INTERIÉR",
    "en": "INTERIOR"
  },
  "urban": {
    "sk": "URBANIZMUS",
    "en": "URBAN"
  },
  "ai": {
    "sk": "AI-ASSISTED",
    "en": "AI-ASSISTED"
  },
  "product": {
    "sk": "PRODUKT",
    "en": "PRODUCT"
  },
  "model": {
    "sk": "MODEL",
    "en": "MODEL"
  }
};
export const PROJECT_ARCHIVE_META = {
  "hotel-bojnice": {
    "title": {
      "sk": "Apartmánové domy Bojnice Resort",
      "en": "Apartmánové domy Bojnice Resort"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-024",
    "typology": {
      "sk": "rekreačný súbor — apartmánové domy",
      "en": "rekreačný súbor — apartmánové domy"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rekreačný súbor — apartmánové domy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Bojnice — Hlboké, Slovensko",
        "basis": "website",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Opakovaný modul s možnosťou priestorovej obmeny",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Bojnice — Hlboké, Slovensko",
      "en": "Bojnice — Hlboké, Slovensko"
    }
  },
  "tiny-house": {
    "title": {
      "sk": "Micro House",
      "en": "Micro House"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-019",
    "typology": {
      "sk": "koncept kompaktného bývania — mikrodom",
      "en": "koncept kompaktného bývania — mikrodom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "koncept kompaktného bývania — mikrodom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Premeny kompaktného objemu a jeho hraníc",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": []
  },
  "bd-severne-mesto": {
    "title": {
      "sk": "RD Košice",
      "en": "RD Košice"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-009",
    "typology": {
      "sk": "mestská vila — rodinný dom s tromi bytmi",
      "en": "mestská vila — rodinný dom s tromi bytmi"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "mestská vila — rodinný dom s tromi bytmi",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Košice, Slovensko",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Tri byty v jednej mestskej vile",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Bytové jednotky",
        "value": "Tri",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Košice, Slovensko",
      "en": "Košice, Slovensko"
    }
  },
  "lozorno-chata": {
    "title": {
      "sk": "Chata v Karpatoch",
      "en": "Chata v Karpatoch"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-017",
    "typology": {
      "sk": "rekreačná chata",
      "en": "rekreačná chata"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rekreačná chata",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Karpaty — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Jeden objem a viac výrazov plášťa",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Karpaty — podľa názvu projektu",
      "en": "Karpaty — podľa názvu projektu"
    }
  },
  "planky": {
    "title": {
      "sk": "RD Plánky",
      "en": "RD Plánky"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-008",
    "typology": {
      "sk": "rekreačný dom",
      "en": "rekreačný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rekreačný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Plánky — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Rekreácia rozložená medzi vnútorné a vonkajšie priestory",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "CLT panely, železobetónová oporná stena a oceľové stĺpy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Plánky — podľa názvu projektu",
      "en": "Plánky — podľa názvu projektu"
    }
  },
  "rd-bac": {
    "title": {
      "sk": "RD Báč",
      "en": "RD Báč"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-007",
    "typology": {
      "sk": "rodinný dom — drevostavba",
      "en": "rodinný dom — drevostavba"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom — drevostavba",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Báč, Slovensko",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Prízemné bývanie prepojené so záhradou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "CLT panely doplnené KVH prvkami",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Báč, Slovensko",
      "en": "Báč, Slovensko"
    }
  },
  "zs-ivana-bukovcana": {
    "title": {
      "sk": "ZŠ Ivana Bukovčana",
      "en": "Ivana Bukovčana Primary School"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Public and commercial"
    },
    "typology": {
      "sk": "Prístavba a nadstavba základnej školy",
      "en": "Primary school extension"
    },
    "location": {
      "sk": "Bratislava – Devínska Nová Ves",
      "en": "Bratislava – Devínska Nová Ves"
    },
    "years": [
      {
        "kind": "Rok realizácie",
        "value": "2023",
        "status": "verified",
        "source_ids": [
          "cezaar"
        ]
      }
    ],
    "aside": [
      {
        "label": "Kľúčová téma",
        "value": "Rozšírenie školy drevenou nadstavbou a novým pavilónom pri ihrisku"
      },
      {
        "label": "Miesto",
        "value": "Ivana Bukovčana 3, Bratislava – Devínska Nová Ves"
      },
      {
        "label": "Typológia",
        "value": "Prístavba a nadstavba základnej školy"
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Martin Hudec, Katarína Bergerová · AtomStudio",
        "source_ids": [
          "cezaar"
        ]
      },
      {
        "role": "Spolupráca pri realizácii",
        "name": "Daniel Kubiš",
        "source_ids": [
          "cezaar"
        ]
      },
      {
        "role": "Pôvodná škola",
        "name": "Stavoprojekt Trnava, ateliér 205 pod vedením Ing. Suchého",
        "source_ids": [
          "autori"
        ]
      },
      {
        "role": "Zhotoviteľ",
        "name": "Úsporné drevodomy",
        "source_ids": [
          "drevostavba"
        ]
      },
      {
        "role": "Fotografie",
        "name": "Matej Hakár",
        "source_ids": [
          "cezaar"
        ]
      }
    ]
  },
  "ka-001": {
    "title": {
      "sk": "Rekonštrukcia átria ZŠ",
      "en": "Rekonštrukcia átria ZŠ"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-001",
    "typology": {
      "sk": "školské átrium — revitalizácia",
      "en": "školské átrium — revitalizácia"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "školské átrium — revitalizácia",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Záhrada ako súčasť školského dňa",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-002": {
    "title": {
      "sk": "Telocvičňa DNV",
      "en": "Telocvičňa DNV"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-002",
    "typology": {
      "sk": "športová stavba — telocvičňa",
      "en": "športová stavba — telocvičňa"
    },
    "years": [
      {
        "kind": "začiatok výstavby",
        "value": "2025",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": "Uvádzaný rok začiatku; nepotvrdzuje dokončenie."
      },
      {
        "kind": "plánované dokončenie",
        "value": "2027",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": "Plánovaný termín podľa projektového prehľadu ASB, nie skutočné dokončenie."
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "športová stavba — telocvičňa",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Bratislava — Devínska Nová Ves, areál ZŠ Ivana Bukovčana",
        "basis": "website",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "label": "Začiatok výstavby",
        "value": "2025",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Plánované dokončenie",
        "value": "2027",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Spoločné zázemie pre školu a šport",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Daniel Kubiš, Martin Plošický / KubisArchitekti",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "location": {
      "sk": "Bratislava — Devínska Nová Ves, areál ZŠ Ivana Bukovčana",
      "en": "Bratislava — Devínska Nová Ves, areál ZŠ Ivana Bukovčana"
    },
    "team": {
      "sk": "Architektúra: Daniel Kubiš, Martin Plošický / KubisArchitekti",
      "en": "Architektúra: Daniel Kubiš, Martin Plošický / KubisArchitekti"
    }
  },
  "ka-003": {
    "title": {
      "sk": "Parkovací dom",
      "en": "Parkovací dom"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-003",
    "typology": {
      "sk": "dopravná stavba — parkovací dom",
      "en": "dopravná stavba — parkovací dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "dopravná stavba — parkovací dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Parkovanie usporiadané podľa terénu a pohybu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "rd-tekula": {
    "title": {
      "sk": "RD Tekula",
      "en": "RD Tekula"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-004",
    "typology": {
      "sk": "rodinný dom — rekonštrukcia a prístavba",
      "en": "rodinný dom — rekonštrukcia a prístavba"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom — rekonštrukcia a prístavba",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Bernolákova ulica — obec neuvedená",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Nové vrstvy pri zachovanom dome",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Rozsah",
        "value": "Rekonštrukcia existujúceho domu, obytná prístavba a coffee point",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Svätý Jur",
      "en": "Svätý Jur"
    },
    "team": {
      "sk": "Ing. arch. Daniel Kubiš, Ing. Martin Plošický",
      "en": "Ing. arch. Daniel Kubiš, Ing. Martin Plošický"
    }
  },
  "ka-005": {
    "title": {
      "sk": "RD DNV",
      "en": "RD DNV"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-005",
    "typology": {
      "sk": "rodinný dom",
      "en": "rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "DNV — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Hmota domu poskladaná okolo záhrady",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "DNV — podľa názvu projektu",
      "en": "DNV — podľa názvu projektu"
    }
  },
  "ka-006": {
    "title": {
      "sk": "RD Borinka",
      "en": "RD Borinka"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-006",
    "typology": {
      "sk": "rodinný dom — drevostavba",
      "en": "rodinný dom — drevostavba"
    },
    "years": [
      {
        "kind": "návrh",
        "value": "2020–2021",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": ""
      },
      {
        "kind": "realizácia",
        "value": "2021–2022",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": ""
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom — drevostavba",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Borinka, Slovensko",
        "basis": "website",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "label": "Návrh",
        "value": "2020–2021",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2021–2022",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Bývanie sústredené okolo zeleného átria",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Dispozícia",
        "value": "Denná, nočná a technicko-obslužná časť",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Daniel Kubiš, Martin Plošický",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "role": "Interiér",
        "name": "Lucia Vlasáková, Barbora Luptáková",
        "source_ids": [
          "s3"
        ]
      },
      {
        "role": "Záhrada",
        "name": "Martin Malachovský, Zuzana Demovičová",
        "source_ids": [
          "s3"
        ]
      },
      {
        "role": "Fotografie",
        "name": "Matúš Nedecký",
        "source_ids": [
          "s2",
          "s3"
        ]
      }
    ],
    "location": {
      "sk": "Borinka, Slovensko",
      "en": "Borinka, Slovensko"
    },
    "team": {
      "sk": "Architektúra: Daniel Kubiš, Martin Plošický; Interiér: Lucia Vlasáková, Barbora Luptáková; Záhrada: Martin Malachovský, Zuzana Demovičová; Fotografie: Matúš Nedecký",
      "en": "Architektúra: Daniel Kubiš, Martin Plošický; Interiér: Lucia Vlasáková, Barbora Luptáková; Záhrada: Martin Malachovský, Zuzana Demovičová; Fotografie: Matúš Nedecký"
    }
  },
  "ka-010": {
    "title": {
      "sk": "RD Záhorie",
      "en": "RD Záhorie"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-010",
    "typology": {
      "sk": "rodinný dom",
      "en": "rodinný dom"
    },
    "years": [
      {
        "kind": "návrh",
        "value": "2024",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": ""
      },
      {
        "kind": "realizácia",
        "value": "2024–2025",
        "status": "verified",
        "source_ids": [
          "s2",
          "s3"
        ],
        "note": ""
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Stupava, Slovensko",
        "basis": "website",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "label": "Návrh",
        "value": "2024",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2024–2025",
        "basis": "website",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Rytmus svetla medzi domom a záhradou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Dispozícia",
        "value": "Denná časť na prízemí, hlavná nočná časť na poschodí",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Daniel Kubiš / KubisArchitekti",
        "source_ids": [
          "s2"
        ]
      },
      {
        "role": "Spolupráca na architektúre",
        "name": "Martin Plošický / KubisArchitekti",
        "source_ids": [
          "s2"
        ]
      },
      {
        "role": "Interiér",
        "name": "toøl interior architects — Lucia Vlasáková, Barbora Luptáková",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "role": "Záhrada",
        "name": "MILS — Martin Malachovský",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "role": "Fotografie",
        "name": "foter.sk — Matúš Nedecký",
        "source_ids": [
          "site",
          "s2"
        ]
      }
    ],
    "location": {
      "sk": "Stupava, Slovensko",
      "en": "Stupava, Slovensko"
    },
    "team": {
      "sk": "Architektúra: Daniel Kubiš / KubisArchitekti; Spolupráca na architektúre: Martin Plošický / KubisArchitekti; Interiér: toøl interior architects — Lucia Vlasáková, Barbora Luptáková; Záhrada: MILS — Martin Malachovský; Fotografie: foter.sk — Matúš Nedecký",
      "en": "Architektúra: Daniel Kubiš / KubisArchitekti; Spolupráca na architektúre: Martin Plošický / KubisArchitekti; Interiér: toøl interior architects — Lucia Vlasáková, Barbora Luptáková; Záhrada: MILS — Martin Malachovský; Fotografie: foter.sk — Matúš Nedecký"
    }
  },
  "ka-011": {
    "title": {
      "sk": "Rovinka",
      "en": "Rovinka"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-011",
    "typology": {
      "sk": "rodinný dom — drevostavba",
      "en": "rodinný dom — drevostavba"
    },
    "years": [
      {
        "kind": "návrh",
        "value": "2020",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": ""
      },
      {
        "kind": "realizácia",
        "value": "2022–2023",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": ""
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom — drevostavba",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Rovinka, Slovensko",
        "basis": "website",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "label": "Návrh",
        "value": "2020",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2022–2023",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Tri časti domu okolo záhradného priestoru",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "CLT panely a drevená stĺpiková konštrukcia",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Daniel Kubiš; spolupráca Martin Plošický",
        "source_ids": [
          "s2"
        ]
      },
      {
        "role": "Interiér",
        "name": "Lucia Vlasáková, Barbora Luptáková",
        "source_ids": [
          "s3"
        ]
      },
      {
        "role": "Záhrada",
        "name": "Martin Malachovský, Dominika Lovasíková",
        "source_ids": [
          "s3"
        ]
      },
      {
        "role": "Fotografie",
        "name": "Matúš Nedecký / foter.sk",
        "source_ids": [
          "s2",
          "s3"
        ]
      }
    ],
    "location": {
      "sk": "Rovinka, Slovensko",
      "en": "Rovinka, Slovensko"
    },
    "team": {
      "sk": "Architektúra: Daniel Kubiš; spolupráca Martin Plošický; Interiér: Lucia Vlasáková, Barbora Luptáková; Záhrada: Martin Malachovský, Dominika Lovasíková; Fotografie: Matúš Nedecký / foter.sk",
      "en": "Architektúra: Daniel Kubiš; spolupráca Martin Plošický; Interiér: Lucia Vlasáková, Barbora Luptáková; Záhrada: Martin Malachovský, Dominika Lovasíková; Fotografie: Matúš Nedecký / foter.sk"
    }
  },
  "ka-012": {
    "title": {
      "sk": "Hlohovec - Prístavba dentálneho centra",
      "en": "Hlohovec - Prístavba dentálneho centra"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-012",
    "typology": {
      "sk": "zdravotnícka stavba — prístavba dentálneho centra",
      "en": "zdravotnícka stavba — prístavba dentálneho centra"
    },
    "years": [
      {
        "kind": "realizácia",
        "value": "2020",
        "status": "verified",
        "source_ids": [
          "s2",
          "s3"
        ],
        "note": ""
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "zdravotnícka stavba — prístavba dentálneho centra",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Rudolfa Dilonga 2619/1, Hlohovec, Slovensko",
        "basis": "website",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2020",
        "basis": "website",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Drevo ako spoločný jazyk prístavby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "Pohľadové CLT stenové a stropné panely",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Daniel Kubiš, Mária Šebová, Martin Plošický / KubisArchitekti",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "role": "Fotografie",
        "name": "Michal Lachkovič",
        "source_ids": [
          "s2",
          "s3"
        ]
      }
    ],
    "location": {
      "sk": "Rudolfa Dilonga 2619/1, Hlohovec, Slovensko",
      "en": "Rudolfa Dilonga 2619/1, Hlohovec, Slovensko"
    },
    "team": {
      "sk": "Architektúra: Daniel Kubiš, Mária Šebová, Martin Plošický / KubisArchitekti; Fotografie: Michal Lachkovič",
      "en": "Architektúra: Daniel Kubiš, Mária Šebová, Martin Plošický / KubisArchitekti; Fotografie: Michal Lachkovič"
    }
  },
  "ka-013": {
    "title": {
      "sk": "Rekonštrukcia nemocničného pavilónu",
      "en": "Rekonštrukcia nemocničného pavilónu"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-013",
    "typology": {
      "sk": "zdravotnícka stavba — rekonštrukcia nemocničného pavilónu",
      "en": "zdravotnícka stavba — rekonštrukcia nemocničného pavilónu"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "zdravotnícka stavba — rekonštrukcia nemocničného pavilónu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Pezinok, Slovensko",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Obnova pavilónu s novými pobytovými priestormi",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Rozsah",
        "value": "Rekonštrukcia nemocničného pavilónu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Pezinok, Slovensko",
      "en": "Pezinok, Slovensko"
    }
  },
  "ka-014": {
    "title": {
      "sk": "Záhorská Bystrica",
      "en": "Záhorská Bystrica"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-014",
    "typology": {
      "sk": "rodinný dom — drevostavba",
      "en": "rodinný dom — drevostavba"
    },
    "years": [
      {
        "kind": "realizácia",
        "value": "2018–2019",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": "Archiweb uvádza dokončenie v roku 2019."
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom — drevostavba",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Bratislava — Záhorská Bystrica, Slovensko",
        "basis": "website",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2018–2019",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Súvislý drevený plášť na okraji lesa",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "CLT panely a doplnkové stĺpikové drevené panely",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Daniel Kubiš, Martin Hudec; Zsolt Nagy",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "role": "Záhrada",
        "name": "Martin Malachovský",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "role": "Interiér",
        "name": "Lucia Vlasáková",
        "source_ids": [
          "s3"
        ]
      },
      {
        "role": "Zhotoviteľ",
        "name": "Úsporne Drevodomy",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "role": "Fotografie",
        "name": "Michal Lachkovič",
        "source_ids": [
          "s2",
          "s3"
        ]
      }
    ],
    "location": {
      "sk": "Bratislava — Záhorská Bystrica, Slovensko",
      "en": "Bratislava — Záhorská Bystrica, Slovensko"
    },
    "team": {
      "sk": "Architektúra: Daniel Kubiš, Martin Hudec; Zsolt Nagy; Záhrada: Martin Malachovský; Interiér: Lucia Vlasáková; Zhotoviteľ: Úsporne Drevodomy; Fotografie: Michal Lachkovič",
      "en": "Architektúra: Daniel Kubiš, Martin Hudec; Zsolt Nagy; Záhrada: Martin Malachovský; Interiér: Lucia Vlasáková; Zhotoviteľ: Úsporne Drevodomy; Fotografie: Michal Lachkovič"
    }
  },
  "ka-015": {
    "title": {
      "sk": "Mýto",
      "en": "Mýto"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-015",
    "typology": {
      "sk": "rekreačný súbor — štyri domy",
      "en": "rekreačný súbor — štyri domy"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rekreačný súbor — štyri domy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Mýto, prostredie pod Chopkom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Horský pobyt za preskleným lamelovým priečelím",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Šesť osôb v každom dome",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [
      {
        "role": "Vizualizácie",
        "name": "FlyingArchitecture",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "location": {
      "sk": "Mýto, prostredie pod Chopkom",
      "en": "Mýto, prostredie pod Chopkom"
    },
    "team": {
      "sk": "Vizualizácie: FlyingArchitecture",
      "en": "Vizualizácie: FlyingArchitecture"
    }
  },
  "ka-016": {
    "title": {
      "sk": "RD Devín",
      "en": "RD Devín"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-016",
    "typology": {
      "sk": "rodinný dom — drevostavba s využitím existujúcej podnože",
      "en": "rodinný dom — drevostavba s využitím existujúcej podnože"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom — drevostavba s využitím existujúcej podnože",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Devín — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Nová obytná vrstva na existujúcej podnoži",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "CLT panely na existujúcich železobetónových stenách",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Devín — podľa názvu projektu",
      "en": "Devín — podľa názvu projektu"
    }
  },
  "ka-018": {
    "title": {
      "sk": "Dvojdom Mlyny",
      "en": "Dvojdom Mlyny"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-018",
    "typology": {
      "sk": "dvojdom",
      "en": "dvojdom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "dvojdom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Mlyny — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dvojica domov v odstupňovanej svetlej kompozícii",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Mlyny — podľa názvu projektu",
      "en": "Mlyny — podľa názvu projektu"
    }
  },
  "ka-020": {
    "title": {
      "sk": "RD Záhorie",
      "en": "RD Záhorie"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-020",
    "typology": {
      "sk": "rodinný dom",
      "en": "rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Záhorie — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Záhrada medzi jednotlivými časťami domu",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Záhorie — podľa názvu projektu",
      "en": "Záhorie — podľa názvu projektu"
    }
  },
  "ka-021": {
    "title": {
      "sk": "Tále",
      "en": "Tále"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-021",
    "typology": {
      "sk": "apartmánový dom",
      "en": "apartmánový dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "apartmánový dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Tále — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Spoločný parter a samostatné apartmánové priestory",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Tále — podľa názvu projektu",
      "en": "Tále — podľa názvu projektu"
    }
  },
  "ka-022": {
    "title": {
      "sk": "RD Pernek",
      "en": "RD Pernek"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-022",
    "typology": {
      "sk": "rodinný dom",
      "en": "rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Pernek — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dvor vytvorený medzi jednotlivými obytnými objemami",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Pernek — podľa názvu projektu",
      "en": "Pernek — podľa názvu projektu"
    }
  },
  "ka-023": {
    "title": {
      "sk": "RD Žilina",
      "en": "RD Žilina"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-023",
    "typology": {
      "sk": "rodinný dom",
      "en": "rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Žilina — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Rozdielne tváre ulice a záhradného dvora",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Žilina — podľa názvu projektu",
      "en": "Žilina — podľa názvu projektu"
    }
  },
  "ka-025": {
    "title": {
      "sk": "Čierna voda",
      "en": "Čierna voda"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-025",
    "typology": {
      "sk": "rodinný dom — drevostavba",
      "en": "rodinný dom — drevostavba"
    },
    "years": [
      {
        "kind": "návrh",
        "value": "2017–2018",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": ""
      },
      {
        "kind": "realizácia",
        "value": "2018–2019",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": ""
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom — drevostavba",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Miesto",
        "value": "Čierna Voda, Chorvátsky Grob, Slovensko",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Návrh",
        "value": "2017–2018",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2018–2019",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Súkromná záhrada za kompaktnou uličnou hranicou",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "Drevená sendvičová konštrukcia, kombinované oceľovo-drevené stropy",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Daniel Kubiš, Martin Hudec",
        "source_ids": [
          "s2"
        ]
      },
      {
        "role": "Spolupráca",
        "name": "Zsolt Nagy",
        "source_ids": [
          "s2"
        ]
      },
      {
        "role": "Fotografie",
        "name": "Michal Lachkovič",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "location": {
      "sk": "Čierna Voda, Chorvátsky Grob, Slovensko",
      "en": "Čierna Voda, Chorvátsky Grob, Slovensko"
    },
    "team": {
      "sk": "Architektúra: Daniel Kubiš, Martin Hudec; Spolupráca: Zsolt Nagy; Fotografie: Michal Lachkovič",
      "en": "Architektúra: Daniel Kubiš, Martin Hudec; Spolupráca: Zsolt Nagy; Fotografie: Michal Lachkovič"
    }
  },
  "ka-026": {
    "title": {
      "sk": "RD Malacky",
      "en": "RD Malacky"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-026",
    "typology": {
      "sk": "rodinný dom",
      "en": "rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Malacky — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Široká strešná línia nad záhradnou terasou",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Malacky — podľa názvu projektu",
      "en": "Malacky — podľa názvu projektu"
    }
  },
  "ka-027": {
    "title": {
      "sk": "Chata Devín",
      "en": "Chata Devín"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-027",
    "typology": {
      "sk": "rekreačná chata",
      "en": "rekreačná chata"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rekreačná chata",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Devín — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Vrstvenie obytných priestorov v lesnom svahu",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Devín — podľa názvu projektu",
      "en": "Devín — podľa názvu projektu"
    }
  },
  "ka-028": {
    "title": {
      "sk": "RD Kittsee",
      "en": "RD Kittsee"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-028",
    "typology": {
      "sk": "rodinný dom",
      "en": "rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "rodinný dom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Kittsee — podľa názvu projektu (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Chránená záhrada medzi nízkymi svetlými objemami",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Kittsee — podľa názvu projektu",
      "en": "Kittsee — podľa názvu projektu"
    }
  },
  "ka-029": {
    "title": {
      "sk": "Umbra",
      "en": "Umbra"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-029",
    "typology": {
      "sk": "horská chata — kompaktný rekreačný objekt",
      "en": "horská chata — kompaktný rekreačný objekt"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "horská chata — kompaktný rekreačný objekt",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Kompaktný horský pobyt s vlastným zázemím",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-030": {
    "title": {
      "sk": "Myjava",
      "en": "Myjava"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-030",
    "typology": {
      "sk": "Rekonštrukcia a prístavba rodinného domu",
      "en": "Rekonštrukcia a prístavba rodinného domu"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekonštrukcia a prístavba rodinného domu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Myjava (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Pokračovanie usadlosti v novej vrstve",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Rozsah",
        "value": "Rekonštrukcia, prístavba a obytné podkrovie",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Myjava",
      "en": "Myjava"
    }
  },
  "ka-031": {
    "title": {
      "sk": "RD Devín",
      "en": "RD Devín"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-031",
    "typology": {
      "sk": "Rodinný dom — podľa názvu projektu",
      "en": "Rodinný dom — podľa názvu projektu"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom — podľa názvu projektu",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Devín (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Stupňovanie obytných objemov nad svahom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Devín",
      "en": "Devín"
    }
  },
  "ka-032": {
    "title": {
      "sk": "Liptov",
      "en": "Liptov"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-032",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Liptov",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Horská silueta v kompaktnej hmote",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Päťčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Liptov",
      "en": "Liptov"
    }
  },
  "ka-033": {
    "title": {
      "sk": "Polyfunkčný dom",
      "en": "Polyfunkčný dom"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-033",
    "typology": {
      "sk": "Polyfunkčný administratívny dom",
      "en": "Polyfunkčný administratívny dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Polyfunkčný administratívny dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Rozdielne prevádzky pod spoločným obrysom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-034": {
    "title": {
      "sk": "Vrakuňa",
      "en": "Vrakuňa"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-034",
    "typology": {
      "sk": "Rodinný dom — bungalov",
      "en": "Rodinný dom — bungalov"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom — bungalov",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Bratislava – Vrakuňa",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Krytý obvod medzi domom a záhradou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Dispozícia",
        "value": "Denná a nočná časť na opačných koncoch domu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Bratislava – Vrakuňa",
      "en": "Bratislava – Vrakuňa"
    }
  },
  "ka-035": {
    "title": {
      "sk": "Vinohrad",
      "en": "Vinohrad"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-035",
    "typology": {
      "sk": "Rodinný dom vo svahu",
      "en": "Rodinný dom vo svahu"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom vo svahu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Bývanie nad vinohradom otvorené krajine",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Trojčlenná rodina, trvalé bývanie",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-036": {
    "title": {
      "sk": "Edelstal 2",
      "en": "Edelstal 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-036",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [
      {
        "kind": "návrh",
        "value": "2014–2015",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": "Archiweb výslovne uvádza Projekt: 2014–15."
      },
      {
        "kind": "realizácia",
        "value": "2016",
        "status": "verified",
        "source_ids": [
          "s2",
          "s3"
        ],
        "note": "Rok realizácie je uvedený v oboch projektových záznamoch."
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "s2",
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Edelstal, Rakúsko",
        "basis": "website",
        "source_ids": [
          "site",
          "s2",
          "s3"
        ]
      },
      {
        "label": "Návrh",
        "value": "2014–2015",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2016",
        "basis": "website",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dve hmoty pre každodenné bývanie",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Dispozícia",
        "value": "Oddelená denná a nočná časť; dvojúrovňová detská izba",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [
      {
        "role": "Architektúra",
        "name": "Daniel Kubiš, Martin Hudec — KubisArchitekti",
        "source_ids": [
          "s2",
          "s3"
        ]
      },
      {
        "role": "Fotografie v zázname CE ZA AR",
        "name": "Pekné Bývanie",
        "source_ids": [
          "s3"
        ]
      },
      {
        "role": "Fotografie v zázname Archiweb",
        "name": "Jakub Petrík",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "location": {
      "sk": "Edelstal, Rakúsko",
      "en": "Edelstal, Rakúsko"
    },
    "team": {
      "sk": "Architektúra: Daniel Kubiš, Martin Hudec — KubisArchitekti; Fotografie v zázname CE ZA AR: Pekné Bývanie; Fotografie v zázname Archiweb: Jakub Petrík",
      "en": "Architektúra: Daniel Kubiš, Martin Hudec — KubisArchitekti; Fotografie v zázname CE ZA AR: Pekné Bývanie; Fotografie v zázname Archiweb: Jakub Petrík"
    }
  },
  "ka-037": {
    "title": {
      "sk": "Modra",
      "en": "Modra"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-037",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Rekreačná oblasť pri Pezinku",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dom a terasa v zachovanej zeleni",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Dve až tri osoby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Rekreačná oblasť pri Pezinku",
      "en": "Rekreačná oblasť pri Pezinku"
    }
  },
  "ka-038": {
    "title": {
      "sk": "Nitra 3",
      "en": "Nitra 3"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-038",
    "typology": {
      "sk": "Rodinný dom navrhnutý ako pasívny",
      "en": "Rodinný dom navrhnutý ako pasívny"
    },
    "years": [
      {
        "kind": "realizácia",
        "value": "2017",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": "Rok 2017 je uvedený v hlavičke realizácie autorského portfólia."
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom navrhnutý ako pasívny",
        "basis": "website",
        "source_ids": [
          "s2",
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Pri Nitre, Slovensko",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2017",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Otvorený stred ako spojenie domu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [
      {
        "role": "Ateliér — profil realizácie",
        "name": "KubisArchitekti",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "location": {
      "sk": "Pri Nitre, Slovensko",
      "en": "Pri Nitre, Slovensko"
    },
    "team": {
      "sk": "Ateliér — profil realizácie: KubisArchitekti",
      "en": "Ateliér — profil realizácie: KubisArchitekti"
    }
  },
  "ka-039": {
    "title": {
      "sk": "Vinohrady",
      "en": "Vinohrady"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-039",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Bratislava – Vinohrady",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dom nad zachovanými kamennými kaskádami",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štvorčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Bratislava – Vinohrady",
      "en": "Bratislava – Vinohrady"
    }
  },
  "ka-040": {
    "title": {
      "sk": "Sebestačný dom",
      "en": "Sebestačný dom"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-040",
    "typology": {
      "sk": "Kompaktný rekreačný dom",
      "en": "Kompaktný rekreačný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Kompaktný rekreačný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Kompaktný dom s uzatvárateľným plášťom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Dve až štyri osoby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-041": {
    "title": {
      "sk": "Rekonštrukcia bytového domu",
      "en": "Rekonštrukcia bytového domu"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-041",
    "typology": {
      "sk": "Rekonštrukcia bytového domu",
      "en": "Rekonštrukcia bytového domu"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekonštrukcia bytového domu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Nová pobytová vrstva pred fasádou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Rozsah",
        "value": "Zateplenie stien a strechy, doplnenie loggií",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-042": {
    "title": {
      "sk": "Stupava",
      "en": "Stupava"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-042",
    "typology": {
      "sk": "Rekonštrukcia rodinného domu",
      "en": "Rekonštrukcia rodinného domu"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekonštrukcia rodinného domu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Stupava",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Zachovaná ulica a otvorená záhrada",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Dispozícia",
        "value": "Denná časť na prízemí, spálne v podkroví",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Stupava",
      "en": "Stupava"
    }
  },
  "ka-043": {
    "title": {
      "sk": "Houseboat",
      "en": "Houseboat"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-043",
    "typology": {
      "sk": "Plávajúci rodinný dom",
      "en": "Plávajúci rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Plávajúci rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Rameno Dunaja pri Bratislave",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Každodenný život pri vodnej hladine",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štvorčlenná rodina, trvalé bývanie",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Rameno Dunaja pri Bratislave",
      "en": "Rameno Dunaja pri Bratislave"
    }
  },
  "ka-044": {
    "title": {
      "sk": "Wake Lake",
      "en": "Wake Lake"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-044",
    "typology": {
      "sk": "Rekreačný a športový areál",
      "en": "Rekreačný a športový areál"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačný a športový areál",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Zlaté piesky, Bratislava",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Drevená promenáda ako spojenie areálu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Zlaté piesky, Bratislava",
      "en": "Zlaté piesky, Bratislava"
    }
  },
  "ka-045": {
    "title": {
      "sk": "Eko osada",
      "en": "Eko osada"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-045",
    "typology": {
      "sk": "Urbanistický a architektonický návrh rekreačnej osady",
      "en": "Urbanistický a architektonický návrh rekreačnej osady"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Urbanistický a architektonický návrh rekreačnej osady",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Osada Bystrá — presná obec neurčená",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Spoločné prostredie pre rozdielne formy pobytu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Súbor",
        "value": "5 apartmánových a 12 rekreačných domov",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Osada Bystrá — presná obec neurčená",
      "en": "Osada Bystrá — presná obec neurčená"
    }
  },
  "ka-046": {
    "title": {
      "sk": "Stupava 2",
      "en": "Stupava 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-046",
    "typology": {
      "sk": "Konverzia skladu na penzión",
      "en": "Konverzia skladu na penzión"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Konverzia skladu na penzión",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Stupava — širšie centrum",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Nové využitie medzi pôvodnými múrmi",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Stupava — širšie centrum",
      "en": "Stupava — širšie centrum"
    }
  },
  "ka-047": {
    "title": {
      "sk": "Košice",
      "en": "Košice"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-047",
    "typology": {
      "sk": "Rodinná vila",
      "en": "Rodinná vila"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinná vila",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Košice",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Átrium prepájajúce vrstvy rodinnej vily",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štvorčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Košice",
      "en": "Košice"
    }
  },
  "ka-048": {
    "title": {
      "sk": "Rezort rekreačných domov",
      "en": "Rezort rekreačných domov"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-048",
    "typology": {
      "sk": "Rezort rekreačných domov",
      "en": "Rezort rekreačných domov"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rezort rekreačných domov",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Okres Žarnovica",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Opakovaný dom prispôsobený orientácii pozemku",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "Drevostavba",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Okres Žarnovica",
      "en": "Okres Žarnovica"
    }
  },
  "ka-049": {
    "title": {
      "sk": "Kysuce",
      "en": "Kysuce"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-049",
    "typology": {
      "sk": "Rodinný dom vo svahu",
      "en": "Rodinný dom vo svahu"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom vo svahu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Kysuce",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Pozdĺžne bývanie vložené do svahu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Kysuce",
      "en": "Kysuce"
    }
  },
  "ka-050": {
    "title": {
      "sk": "Kostolište",
      "en": "Kostolište"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-050",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Kostolište",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Sedlová a plochá strecha v jednom celku",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štvorčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Kostolište",
      "en": "Kostolište"
    }
  },
  "ka-051": {
    "title": {
      "sk": "Hospodárska usadlosť",
      "en": "Hospodárska usadlosť"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-051",
    "typology": {
      "sk": "Rekreačná hospodárska usadlosť",
      "en": "Rekreačná hospodárska usadlosť"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačná hospodárska usadlosť",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Spoločná strecha nad rozdielnymi funkciami",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štyri až šesť osôb",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-052": {
    "title": {
      "sk": "Dúbravka",
      "en": "Dúbravka"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-052",
    "typology": {
      "sk": "Rekonštrukcia, prístavba a nadstavba rekreačnej chaty",
      "en": "Rekonštrukcia, prístavba a nadstavba rekreačnej chaty"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekonštrukcia, prístavba a nadstavba rekreačnej chaty",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Bratislava – Dúbravka",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Nová obytná vrstva nad svahom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Rozsah",
        "value": "Prístavba a nadstavba",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Bratislava – Dúbravka",
      "en": "Bratislava – Dúbravka"
    }
  },
  "ka-053": {
    "title": {
      "sk": "Marchegg",
      "en": "Marchegg"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-053",
    "typology": {
      "sk": "Rodinný dom na mieste pôvodnej stavby",
      "en": "Rodinný dom na mieste pôvodnej stavby"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom na mieste pôvodnej stavby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Marchegg, Rakúsko",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dve tváre domu medzi ulicou a záhradou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Marchegg, Rakúsko",
      "en": "Marchegg, Rakúsko"
    }
  },
  "ka-055": {
    "title": {
      "sk": "Záhorie",
      "en": "Záhorie"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-055",
    "typology": {
      "sk": "Rekreačná chata",
      "en": "Rekreačná chata"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačná chata",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Záhorie",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Malé zázemie pod výraznou strechou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Jeden pár",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Záhorie",
      "en": "Záhorie"
    }
  },
  "ka-056": {
    "title": {
      "sk": "Dunajská Lužná",
      "en": "Dunajská Lužná"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-056",
    "typology": {
      "sk": "Rekonštrukcia a rozšírenie areálu základnej školy",
      "en": "Rekonštrukcia a rozšírenie areálu základnej školy"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekonštrukcia a rozšírenie areálu základnej školy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Dunajská Lužná (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Rozvoj školy tromi nadväzujúcimi zásahmi",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Rozsah",
        "value": "Tri hlavné zásahy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Dunajská Lužná",
      "en": "Dunajská Lužná"
    }
  },
  "ka-057": {
    "title": {
      "sk": "Čičmany",
      "en": "Čičmany"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-057",
    "typology": {
      "sk": "Konverzia stodoly na rekreačný dom",
      "en": "Konverzia stodoly na rekreačný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Konverzia stodoly na rekreačný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Čičmany",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Nové bývanie v pôvodnej stodole",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Čičmany",
      "en": "Čičmany"
    }
  },
  "ka-058": {
    "title": {
      "sk": "Biskupice",
      "en": "Biskupice"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-058",
    "typology": {
      "sk": "Malý rodinný dom",
      "en": "Malý rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Malý rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Biskupice",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Bývanie vo vrstve pergolovej terasy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Jedna až dve osoby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Biskupice",
      "en": "Biskupice"
    }
  },
  "ka-059": {
    "title": {
      "sk": "Čavoj",
      "en": "Čavoj"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-059",
    "typology": {
      "sk": "Rekonštrukcia a prístavba rekreačnej chalupy",
      "en": "Rekonštrukcia a prístavba rekreačnej chalupy"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekonštrukcia a prístavba rekreačnej chalupy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Čavoj",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Zachovaný charakter chalupy a nové obytné priestory",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Dispozícia",
        "value": "Denná zóna na prízemí, nočná v podkroví",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Čavoj",
      "en": "Čavoj"
    }
  },
  "ka-060": {
    "title": {
      "sk": "Devín 3",
      "en": "Devín 3"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-060",
    "typology": {
      "sk": "Prestavba rekreačnej chaty na celoročné užívanie",
      "en": "Prestavba rekreačnej chaty na celoročné užívanie"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Prestavba rekreačnej chaty na celoročné užívanie",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Devín",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dve hmoty, tri úrovne, chránená terasa",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Trojčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Devín",
      "en": "Devín"
    }
  },
  "ka-061": {
    "title": {
      "sk": "Morava",
      "en": "Morava"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-061",
    "typology": {
      "sk": "Prestavba rekreačnej chaty na celoročné užívanie",
      "en": "Prestavba rekreačnej chaty na celoročné užívanie"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Prestavba rekreačnej chaty na celoročné užívanie",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Morava",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Vysunuté podlažie ako zastrešenie vonkajšieho pobytu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štvorčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Morava",
      "en": "Morava"
    }
  },
  "ka-062": {
    "title": {
      "sk": "Kalinkovo",
      "en": "Kalinkovo"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-062",
    "typology": {
      "sk": "Prestavba rodinného domu",
      "en": "Prestavba rodinného domu"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Prestavba rodinného domu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Kalinkovo",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Obnova domu cez svetlo a kontakt so záhradou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Kalinkovo",
      "en": "Kalinkovo"
    }
  },
  "ka-063": {
    "title": {
      "sk": "Záhorie 2",
      "en": "Záhorie 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-063",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Záhorie",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Otvorená denná časť a krytá ochodza",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Dvojčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Záhorie",
      "en": "Záhorie"
    }
  },
  "ka-064": {
    "title": {
      "sk": "DNV 2",
      "en": "DNV 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-064",
    "typology": {
      "sk": "Rekreačný dom",
      "en": "Rekreačný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Devínska Nová Ves",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Malý dom prispôsobený úzkemu pozemku",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Dve až tri osoby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Devínska Nová Ves",
      "en": "Devínska Nová Ves"
    }
  },
  "ka-065": {
    "title": {
      "sk": "Nitra 2",
      "en": "Nitra 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-065",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Nitra",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dom a záhrada pod spoločným prestrešením",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štvorčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Nitra",
      "en": "Nitra"
    }
  },
  "ka-066": {
    "title": {
      "sk": "Limbach",
      "en": "Limbach"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-066",
    "typology": {
      "sk": "Rekreačná chata",
      "en": "Rekreačná chata"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačná chata",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Limbach",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dve pootočené hmoty medzi zachovanými stromami",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Tri osoby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Limbach",
      "en": "Limbach"
    }
  },
  "ka-067": {
    "title": {
      "sk": "Rača 2",
      "en": "Rača 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-067",
    "typology": {
      "sk": "Vinohradnícka rekreačná chata",
      "en": "Vinohradnícka rekreačná chata"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Vinohradnícka rekreačná chata",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Rača",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Výhľady na vinohrad a rytmus fasády",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Dispozícia",
        "value": "Dvojizbová chata",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Rača",
      "en": "Rača"
    }
  },
  "ka-068": {
    "title": {
      "sk": "Vinohradnícky dom",
      "en": "Vinohradnícky dom"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-068",
    "typology": {
      "sk": "Vinohradnícky dom",
      "en": "Vinohradnícky dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Vinohradnícky dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Devínska Nová Ves",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Bývanie a vinohrad ako jeden priestorový celok",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Až päť osôb",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Devínska Nová Ves",
      "en": "Devínska Nová Ves"
    }
  },
  "ka-069": {
    "title": {
      "sk": "Stupava 4",
      "en": "Stupava 4"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-069",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Stupava",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Súkromie od ulice, otvorenie do záhrady",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Trojčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Stupava",
      "en": "Stupava"
    }
  },
  "ka-070": {
    "title": {
      "sk": "Lamač",
      "en": "Lamač"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-070",
    "typology": {
      "sk": "Rekreačný dom",
      "en": "Rekreačný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Lamač",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Bývanie vložené do strmého zeleného svahu",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štvorčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Lamač",
      "en": "Lamač"
    }
  },
  "ka-071": {
    "title": {
      "sk": "Saliby",
      "en": "Saliby"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-071",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Saliby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Dedinský archetyp s otvorenou záhradnou stranou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štyri osoby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Saliby",
      "en": "Saliby"
    }
  },
  "ka-072": {
    "title": {
      "sk": "Orava",
      "en": "Orava"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-072",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Orava",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Malý dom medzi tradíciou a otvorenou krajinou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Dve až štyri osoby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Orava",
      "en": "Orava"
    }
  },
  "ka-073": {
    "title": {
      "sk": "Bojkovice",
      "en": "Bojkovice"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-073",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Bojkovice, Česko",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Stupňovité bývanie prepojené stromom a galériou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Konštrukcia",
        "value": "CLT panely",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Bojkovice, Česko",
      "en": "Bojkovice, Česko"
    }
  },
  "ka-074": {
    "title": {
      "sk": "Bratislava 2",
      "en": "Bratislava 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-074",
    "typology": {
      "sk": "Verejný park a krajinné úpravy",
      "en": "Verejný park a krajinné úpravy"
    },
    "years": [
      {
        "kind": "návrh",
        "value": "2019–2020",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": "Roky návrhu revitalizácie parku Avion; galéria zachytáva pôvodný koncept."
      },
      {
        "kind": "realizácia",
        "value": "2021",
        "status": "verified",
        "source_ids": [
          "s2"
        ],
        "note": "Rok realizácie parku; realizované betónové záhony a zredukovaný rozsah sa líšia od vizualizácií."
      }
    ],
    "aside": [
      {
        "label": "Typológia",
        "value": "Verejný park a krajinné úpravy",
        "basis": "website",
        "source_ids": [
          "s2",
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Ivanská cesta 16, Bratislava – Avion Shopping Park",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Návrh",
        "value": "2019–2020",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Realizácia",
        "value": "2021",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Zelené zákutia medzi trasami každodenného pohybu",
        "basis": "website",
        "source_ids": [
          "site",
          "s2"
        ]
      },
      {
        "label": "Plocha pozemku",
        "value": "8 220 m² podľa projektového záznamu",
        "basis": "website",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "credits": [
      {
        "role": "Autorský tím",
        "name": "Daniel Kubiš, Martin Malachovský, Martin Hudec, Jakub Budaj, Gabriela Mészáros",
        "source_ids": [
          "s2"
        ]
      },
      {
        "role": "Vizualizácie podľa článku",
        "name": "KubisArchitekti",
        "source_ids": [
          "s2"
        ]
      },
      {
        "role": "Fotografie realizácie v externom článku, mimo tejto galérie",
        "name": "Matej Hakár",
        "source_ids": [
          "s2"
        ]
      }
    ],
    "location": {
      "sk": "Ivanská cesta 16, Bratislava – Avion Shopping Park",
      "en": "Ivanská cesta 16, Bratislava – Avion Shopping Park"
    },
    "team": {
      "sk": "Autorský tím: Daniel Kubiš, Martin Malachovský, Martin Hudec, Jakub Budaj, Gabriela Mészáros; Vizualizácie podľa článku: KubisArchitekti; Fotografie realizácie v externom článku, mimo tejto galérie: Matej Hakár",
      "en": "Autorský tím: Daniel Kubiš, Martin Malachovský, Martin Hudec, Jakub Budaj, Gabriela Mészáros; Vizualizácie podľa článku: KubisArchitekti; Fotografie realizácie v externom článku, mimo tejto galérie: Matej Hakár"
    }
  },
  "ka-075": {
    "title": {
      "sk": "Borinka 3",
      "en": "Borinka 3"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-075",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Borinka",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Prekrížené hmoty ako ochrana vstupu a terasy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Borinka",
      "en": "Borinka"
    }
  },
  "ka-076": {
    "title": {
      "sk": "Zálesie",
      "en": "Zálesie"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-076",
    "typology": {
      "sk": "Dom na vizualizáciách – presnú funkciu treba potvrdiť",
      "en": "Dom na vizualizáciách – presnú funkciu treba potvrdiť"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Dom na vizualizáciách – presnú funkciu treba potvrdiť",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Zálesie (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Presklený štít a jednoduchá sedlová hmota",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Zálesie",
      "en": "Zálesie"
    }
  },
  "ka-077": {
    "title": {
      "sk": "Borinka",
      "en": "Borinka"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-077",
    "typology": {
      "sk": "Rekreačný dom",
      "en": "Rekreačný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Borinka",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Vysunutý obytný priestor na okraji lesa",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Borinka",
      "en": "Borinka"
    }
  },
  "ka-078": {
    "title": {
      "sk": "Devín 2",
      "en": "Devín 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-078",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Devín, Bratislava",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Stupňovanie terás medzi domom a svahom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Devín, Bratislava",
      "en": "Devín, Bratislava"
    }
  },
  "ka-079": {
    "title": {
      "sk": "Vinohrad 2",
      "en": "Vinohrad 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-079",
    "typology": {
      "sk": "Rekonštrukcia rekreačnej chaty",
      "en": "Rekonštrukcia rekreačnej chaty"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekonštrukcia rekreačnej chaty",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Obnovená chata medzi vinohradom a výhľadom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Dvojčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-080": {
    "title": {
      "sk": "Rudava",
      "en": "Rudava"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-080",
    "typology": {
      "sk": "Rekreačná chata",
      "en": "Rekreačná chata"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačná chata",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Malé Leváre, rekreačná oblasť Rudava",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Obytné úrovne otvorené k vodnej hladine",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Dispozícia",
        "value": "Hosťovské priestory na prízemí; dve obytné miestnosti so zázemím hore",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Malé Leváre, rekreačná oblasť Rudava",
      "en": "Malé Leváre, rekreačná oblasť Rudava"
    }
  },
  "ka-081": {
    "title": {
      "sk": "Rekreačný dom pod Tatrami",
      "en": "Rekreačný dom pod Tatrami"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-081",
    "typology": {
      "sk": "Rekreačný dom",
      "en": "Rekreačný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Tatranská oblasť",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Tradičný odkaz a otvorenie do krajiny",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Dve až štyri osoby",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Tatranská oblasť",
      "en": "Tatranská oblasť"
    }
  },
  "ka-082": {
    "title": {
      "sk": "Dom z lodných kontajnerov",
      "en": "Dom z lodných kontajnerov"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Rekreácia a ubytovanie",
      "en": "Rekreácia a ubytovanie"
    },
    "code": "KA-082",
    "typology": {
      "sk": "Rekreačný dom z lodných kontajnerov",
      "en": "Rekreačný dom z lodných kontajnerov"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rekreačný dom z lodných kontajnerov",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Industriálny obal okolo súkromnej vnútornej terasy",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Dvojčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "ka-083": {
    "title": {
      "sk": "Poprad",
      "en": "Poprad"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-083",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Poprad",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Tri úrovne bývania pod jednou strechou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kapacita",
        "value": "Štvorčlenná rodina",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Poprad",
      "en": "Poprad"
    }
  },
  "ka-084": {
    "title": {
      "sk": "Nové Mesto nad Váhom",
      "en": "Nové Mesto nad Váhom"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-084",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Nové Mesto nad Váhom (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Svetlé hmoty a záhradné otvorenie domu",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Nové Mesto nad Váhom",
      "en": "Nové Mesto nad Váhom"
    }
  },
  "ka-085": {
    "title": {
      "sk": "Borinka 4",
      "en": "Borinka 4"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-085",
    "typology": {
      "sk": "Dvojpodlažný dom na fotografiách – presnú funkciu treba potvrdiť",
      "en": "Dvojpodlažný dom na fotografiách – presnú funkciu treba potvrdiť"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Dvojpodlažný dom na fotografiách – presnú funkciu treba potvrdiť",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      },
      {
        "label": "Miesto",
        "value": "Borinka (podľa názvu projektu)",
        "basis": "title",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Drevený obal a otvorený vnútorný priestor",
        "basis": "visual",
        "source_ids": [
          "images"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Borinka",
      "en": "Borinka"
    }
  },
  "ka-086": {
    "title": {
      "sk": "Záhorská Bystrica 2",
      "en": "Záhorská Bystrica 2"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    },
    "code": "KA-086",
    "typology": {
      "sk": "Rodinný dom",
      "en": "Rodinný dom"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Rodinný dom",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Miesto",
        "value": "Záhorská Bystrica",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Tri úrovne terás v jednej bielej hmote",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": [],
    "location": {
      "sk": "Záhorská Bystrica",
      "en": "Záhorská Bystrica"
    }
  },
  "ka-087": {
    "title": {
      "sk": "Strelnica",
      "en": "Strelnica"
    },
    "discipline": "architecture",
    "category": {
      "sk": "Verejné a komerčné",
      "en": "Verejné a komerčné"
    },
    "code": "KA-087",
    "typology": {
      "sk": "Strelnica s kaviarňou",
      "en": "Strelnica s kaviarňou"
    },
    "years": [],
    "aside": [
      {
        "label": "Typológia",
        "value": "Strelnica s kaviarňou",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      },
      {
        "label": "Kľúčová téma",
        "value": "Skrytý objem a otvorený betónový vstup",
        "basis": "website",
        "source_ids": [
          "site"
        ]
      }
    ],
    "credits": []
  },
  "micro-house-2": {
    "title": {
      "sk": "Micro House 2.0",
      "en": "Micro House 2.0"
    },
    "discipline": "architecture",
    "aside": [
      {
        "label": "Kľúčová téma",
        "value": "Kompaktné bývanie prepojené so záhradou"
      }
    ],
    "typology": {
      "sk": "mikrodom",
      "en": "micro house"
    },
    "scope": {
      "sk": "3D model a vizualizácie",
      "en": "3D model and visualizations"
    },
    "role": {
      "sk": "CGI / vizualizácie",
      "en": "CGI / visualizations"
    },
    "team": {
      "sk": "Ing. arch. Daniel Kubiš, Ing. Martin Plošický",
      "en": "Ing. arch. Daniel Kubiš, Ing. Martin Plošický"
    },
    "category": {
      "sk": "Bývanie",
      "en": "Bývanie"
    }
  }
};
export const PROJECT_GALLERY_LAYOUTS = {
  "hotel-bojnice": "full half half half half half half half half half",
  "tiny-house": "full full half half half half half half half half half half half half half half half half half half half half half half half half half half half",
  "bd-severne-mesto": "full full half half half half half",
  "lozorno-chata": "full full half half half half half half half half half",
  "planky": "full half half half half half half half half",
  "rd-bac": "full full full half half half half half",
  "zs-ivana-bukovcana": "full wide half half half half portrait full wide half half wide portrait",
  "ka-001": "full half half half half half half",
  "ka-002": "full half half half half half half",
  "ka-003": "full half half half half",
  "rd-tekula": "full half half half half half half half half half",
  "ka-005": "full half half half half half",
  "ka-006": "full half half half half half half half half half half half half half",
  "ka-010": "full half half half half half half half half half half half half half half",
  "ka-011": "full half half half half half half half half half half half",
  "ka-012": "full half half half half half half half half half half half half half half half half",
  "ka-013": "full half half half half",
  "ka-014": "full half half half",
  "ka-015": "full half half half half half",
  "ka-016": "full half half half half",
  "ka-018": "full half half half",
  "ka-020": "full half half half half half half half half",
  "ka-021": "full half half half half",
  "ka-022": "full half half half",
  "ka-023": "full half half half half half",
  "ka-025": "full half half half half half",
  "ka-026": "full half half",
  "ka-027": "full half half half half",
  "ka-028": "full half half half",
  "ka-029": "full half half half half half half half half",
  "ka-030": "full half half half",
  "ka-031": "full half half",
  "ka-032": "full half half",
  "ka-033": "full half half",
  "ka-034": "full half half half",
  "ka-035": "full half half",
  "ka-036": "full half half half half half half half half",
  "ka-037": "full half half",
  "ka-038": "full half half half half half half",
  "ka-039": "full half half half half half",
  "ka-040": "full half half half",
  "ka-041": "full half half",
  "ka-042": "full half half",
  "ka-043": "full half half half half",
  "ka-044": "full half half half half half half",
  "ka-045": "full half half half",
  "ka-046": "full half half",
  "ka-047": "full half half half half half",
  "ka-048": "full half half",
  "ka-049": "full half half",
  "ka-050": "full half half",
  "ka-051": "full half half half",
  "ka-052": "full half half",
  "ka-053": "full half half half half",
  "ka-055": "full half half",
  "ka-056": "full half half half",
  "ka-057": "full half half half",
  "ka-058": "full half half",
  "ka-059": "full half",
  "ka-060": "full half half half",
  "ka-061": "full half half half",
  "ka-062": "full half half",
  "ka-063": "full half half",
  "ka-064": "full half half",
  "ka-065": "full half half half",
  "ka-066": "full half half",
  "ka-067": "full half half",
  "ka-068": "full half",
  "ka-069": "full half half",
  "ka-070": "full half half",
  "ka-071": "full half half",
  "ka-072": "full half half half",
  "ka-073": "full half half",
  "ka-074": "full half half",
  "ka-075": "full half half",
  "ka-076": "full half half",
  "ka-077": "full half half",
  "ka-078": "full half half",
  "ka-079": "full half half",
  "ka-080": "full half half",
  "ka-081": "full half half",
  "ka-082": "full half half",
  "ka-083": "full half half",
  "ka-084": "full half half",
  "ka-085": "full half half",
  "ka-086": "full half half",
  "ka-087": "full half half half half half",
  "micro-house-2": "full half half portrait half half half half portrait square wide"
};